import React, { useEffect, useRef } from "react";

// SASS
import "./Part4.scss";

// COMPONENTS
import Step from "../Step/Step";

// HELPERS
import animate from "../../utils/animate";

// LIBRARIES
import scrollama from "scrollama";

// ASSETS
import treeImg from "../../assets/img/tree-2.png";
import parkBackgroundImg from "../../assets/img/park-background-1.png";
import arrowImg from "../../assets/img/arrow.svg";
import leafImg from "../../assets/img/green-leaf.svg";
import leaf2Img from "../../assets/img/green-leaf-2.svg";
import neighborhoodBackgroundImg from "../../assets/img/neighborhood-background.png";
import houseSceneOneImg from "../../assets/img/house-scene-1.png";
import houseSceneTwoImg from "../../assets/img/house-scene-2.png";
import houseSceneThreeImg from "../../assets/img/house-scene-3.png";
import houseSceneFourImg from "../../assets/img/house-scene-4.png";
import houseSceneFiveOrangeImg from "../../assets/img/house-scene-5-orange.png";
import germThreeOrangeImg from "../../assets/img/germ-3-orange.svg";
import germSixOrangeImg from "../../assets/img/germ-6-orange.svg";
import germOneOrangeImg from "../../assets/img/germ-1-orange.svg";
import blockHouseImg from "../../assets/img/house-scene-6.png";
import waitingRoomBackgroundImg from "../../assets/img/waiting-room-background.png";
import blockToddlerImg from "../../assets/img/child-blocks.png";
import nurseProfileImg from "../../assets/img/nurse-3-profile_v2-min.png";
import blueGerm from "../../assets/img/germ-2.svg";

export default function Part3({ step }) {
  const scrolly = scrollama();

  const treeSceneEl = useRef(null);
  const leafSceneEl = useRef(null);
  const treeLeafOneEl = useRef(null);
  const treeLeafTwoEl = useRef(null);
  const treeLeafThreeEl = useRef(null);
  const treeLeafFourEl = useRef(null);
  const greenLeafOneEl = useRef(null);
  const greenLeafTwoEl = useRef(null);
  const greenLeafThreeEl = useRef(null);
  const windOneEl = useRef(null);
  const windTwoEl = useRef(null);
  const houseExteriorSceneEl = useRef(null);
  const houseExteriorSceneBackgroundEl = useRef(null);
  const houseExteriorImgSceneOneEl = useRef(null);
  const houseExteriorImgSceneTwoEl = useRef(null);
  const houseExteriorImgSceneThreeEl = useRef(null);
  const houseExteriorImgSceneFourEl = useRef(null);
  const houseExteriorImgSceneFiveEl = useRef(null);
  const houseExteriorTextSceneOneEl = useRef(null);
  const houseExteriorTextSceneTwoEl = useRef(null);
  const houseExteriorTextSceneThreeEl = useRef(null);
  const houseExteriorTextSceneFourEl = useRef(null);
  const houseExteriorTextSceneFiveEl = useRef(null);
  const germOneImgEl = useRef(null);
  const germTwoImgEl = useRef(null);
  const germThreeImgEl = useRef(null);
  const blockHouseEl = useRef(null);
  const nurseProfileEl = useRef(null);
  const waitingRoomSceneEl = useRef(null);
  const blueGermEl = useRef(null);
  const nurseProfileSceneEl = useRef(null);
  const eyesTextBlockEl = useRef(null);
  const noseTextBlockEl = useRef(null);
  const mouthTextBlockEl = useRef(null);
  const leafTextBlockOneEl = useRef(null);
  const leafTextBlockTwoEl = useRef(null);
  const leafTextBlockThreeEl = useRef(null);
  const leafTextBlockFourEl = useRef(null);
  const turquoiseBlockEl = useRef(null);

  const animationSequence = [
    { height: "750px", description: "spacer" },
    { height: null, description: "move leaves" },
    { height: null, description: "move leaves" },
    { height: "1000px", description: "move leaves, show arrows and text" },
    { height: null, description: "fade out tree scene" },
    { height: "1500px", description: "fade in leaf scene" },
    { height: null, description: "fade out leaf scene" },
    { height: "750px", description: "fade in house exterior scene" },
    { height: "750px", description: "fade in house state2" },
    { height: "750px", description: "fade in house state3" },
    { height: "750px", description: "fade in house state4" },
    {
      height: "750px",
      description:
        "fade out house exterior scene, fade in germs and gunk block house",
    },
    {
      height: "750px",
      description:
        "fade out gunk block house and germs, fade in gunkless block house",
    },
    {
      height: "750px",
      description:
        "shrink gunk block house, fade in nurse profile, fade in waiting room scene, fade in germ (delay 500ms)",
    },
    {
      height: "750px",
      description:
        "fade out gunkless block bouse, fade out waiting room scene, zoom and move nurse profile, fade in nurse profile scene",
    },
    {
      height: "750px",
      description: "show eyes text block",
    },
    {
      height: "750px",
      description: "show eyes nose block",
    },
    {
      height: "750px",
      description: "show eyes mouth block",
    },
    {
      height: "750px",
      description: "spacer",
    },
  ];

  useEffect(() => {
    scrolly
      .setup({
        step: `.${step}`,
        debug: false,
        threshold: 1,
        progress: true,
      })
      .onStepEnter(({ index, direction }) => {
        switch (index) {
          case 1: {
            animate.addClassOnEnter(
              treeLeafOneEl.current,
              "moved-1",
              direction
            );
            animate.addClassOnEnter(
              treeLeafTwoEl.current,
              "moved-1",
              direction
            );
            //animate.fadeOutOnEnter(leafTextBlockOneEl.current, direction);
            animate.fadeInOnEnter(leafTextBlockTwoEl.current, direction);
            break;
          }
          case 2: {
            animate.addClassOnEnter(
              treeLeafOneEl.current,
              "moved-2",
              direction
            );
            animate.addClassOnEnter(
              treeLeafTwoEl.current,
              "moved-2",
              direction
            );
            animate.addClassOnEnter(
              treeLeafThreeEl.current,
              "moved-1",
              direction
            );
            animate.addClassOnEnter(
              treeLeafFourEl.current,
              "moved-1",
              direction
            );
            //animate.fadeOutOnEnter(leafTextBlockTwoEl.current, direction);
            animate.fadeInOnEnter(leafTextBlockThreeEl.current, direction);
            break;
          }
          case 3: {
            animate.addClassOnEnter(
              treeLeafThreeEl.current,
              "moved-2",
              direction
            );
            animate.addClassOnEnter(
              treeLeafFourEl.current,
              "moved-2",
              direction
            );
            animate.fadeInOnEnter(windOneEl.current, direction);
            animate.fadeInOnEnter(windTwoEl.current, direction);
            animate.fadeOutOnEnter(leafTextBlockOneEl.current, direction);
            animate.fadeInOnEnter(leafTextBlockFourEl.current, direction);
            break;
          }
          case 4: {
            animate.fadeOutOnEnter(treeSceneEl.current, direction);
            break;
          }
          case 5: {
            animate.fadeInOnEnter(leafSceneEl.current, direction);
            animate.addClassOnEnter(greenLeafOneEl.current, "moved", direction);
            animate.addClassOnEnter(greenLeafTwoEl.current, "moved", direction);
            animate.addClassOnEnter(
              greenLeafThreeEl.current,
              "moved",
              direction
            );
            break;
          }
          case 6: {
            animate.fadeOutOnEnter(leafSceneEl.current, direction);
            break;
          }
          case 7: {
            animate.fadeInOnEnter(houseExteriorSceneEl.current, direction);
            break;
          }
          case 8: {
            animate.fadeInOnEnter(
              houseExteriorImgSceneTwoEl.current,
              direction
            );
            animate.fadeOutOnEnter(
              houseExteriorTextSceneOneEl.current,
              direction
            );
            animate.fadeInOnEnter(
              houseExteriorTextSceneTwoEl.current,
              direction
            );
            break;
          }
          case 9: {
            animate.fadeInOnEnter(
              houseExteriorImgSceneThreeEl.current,
              direction
            );
            animate.fadeOutOnEnter(
              houseExteriorTextSceneTwoEl.current,
              direction
            );
            animate.fadeInOnEnter(
              houseExteriorTextSceneThreeEl.current,
              direction
            );
            break;
          }
          case 10: {
            animate.fadeInOnEnter(
              houseExteriorImgSceneFourEl.current,
              direction
            );
            animate.fadeOutOnEnter(
              houseExteriorTextSceneThreeEl.current,
              direction
            );
            animate.fadeInOnEnter(
              houseExteriorTextSceneFourEl.current,
              direction
            );
            break;
          }
          case 11: {
            if (direction === "down") {
              fadeAllHouses();
              unfadeOrangeGerms();
            }
            animate.fadeOutOnEnter(
              houseExteriorSceneBackgroundEl.current,
              direction
            );
            animate.fadeInOnEnter(
              houseExteriorImgSceneFiveEl.current,
              direction
            );
            animate.fadeOutOnEnter(
              houseExteriorTextSceneFourEl.current,
              direction
            );
            animate.fadeInOnEnter(
              houseExteriorTextSceneFiveEl.current,
              direction
            );
            break;
          }
          case 12: {
            if (direction === "down") {
              fadeOrangeGerms();
            }
            animate.fadeInOnEnter(blockHouseEl.current, direction);
            animate.fadeOutOnEnter(
              houseExteriorImgSceneFiveEl.current,
              direction
            );
            animate.fadeOutOnEnter(
              houseExteriorTextSceneFiveEl.current,
              direction
            );
            break;
          }
          case 13: {
            animate.fadeInOnEnter(nurseProfileEl.current, direction);
            animate.fadeInOnEnter(waitingRoomSceneEl.current, direction);
            animate.addClassOnEnter(blockHouseEl.current, "moved", direction);
            setTimeout(() => {
              animate.fadeInOnEnter(blueGermEl.current, direction);
            }, 500);
            break;
          }
          case 14: {
            animate.fadeOutOnEnter(waitingRoomSceneEl.current, direction);
            animate.fadeOutOnEnter(blockHouseEl.current, direction);
            animate.fadeOutOnEnter(blueGermEl.current, direction);
            animate.addClassOnEnter(nurseProfileEl.current, "moved", direction);
            animate.fadeInOnEnter(nurseProfileSceneEl.current, direction);
            animate.addClassOnEnter(
              turquoiseBlockEl.current,
              "moved",
              direction
            );
            break;
          }
          case 15: {
            animate.fadeInOnEnter(eyesTextBlockEl.current, direction);
            break;
          }
          case 16: {
            animate.fadeInOnEnter(noseTextBlockEl.current, direction);
            break;
          }
          case 17: {
            animate.fadeInOnEnter(mouthTextBlockEl.current, direction);
            break;
          }
          default:
            break;
        }
      })
      .onStepProgress(({ index, progress }) => {
        switch (index) {
          case 1: {
            // moveLeavessOneTwoStep1(progress);
            break;
          }
          case 2: {
            // moveLeavessOneTwoStep2(progress);
            // moveLeavesThreeFourStep1([progress]);
            break;
          }
          default:
            break;
        }
      })
      .onStepExit(({ index, direction }) => {
        switch (index) {
          case 1: {
            animate.removeClassOnExit(
              treeLeafOneEl.current,
              "moved-1",
              direction
            );
            animate.removeClassOnExit(
              treeLeafTwoEl.current,
              "moved-1",
              direction
            );
            animate.fadeInOnExit(leafTextBlockOneEl.current, direction);
            animate.fadeOutOnExit(leafTextBlockTwoEl.current, direction);

            break;
          }
          case 2: {
            animate.removeClassOnExit(
              treeLeafOneEl.current,
              "moved-2",
              direction
            );
            animate.removeClassOnExit(
              treeLeafTwoEl.current,
              "moved-2",
              direction
            );
            animate.removeClassOnExit(
              treeLeafThreeEl.current,
              "moved-1",
              direction
            );
            animate.removeClassOnExit(
              treeLeafFourEl.current,
              "moved-1",
              direction
            );
            animate.fadeInOnExit(leafTextBlockTwoEl.current, direction);
            animate.fadeOutOnExit(leafTextBlockThreeEl.current, direction);
            break;
          }
          case 3: {
            animate.removeClassOnExit(
              treeLeafThreeEl.current,
              "moved-2",
              direction
            );
            animate.removeClassOnExit(
              treeLeafFourEl.current,
              "moved-2",
              direction
            );
            animate.fadeOutOnExit(windOneEl.current, direction);
            animate.fadeOutOnExit(windTwoEl.current, direction);
            animate.fadeInOnExit(leafTextBlockOneEl.current, direction);
            animate.fadeOutOnExit(leafTextBlockFourEl.current, direction);
            break;
          }
          case 4: {
            animate.fadeInOnExit(treeSceneEl.current, direction);
            break;
          }
          case 5: {
            animate.fadeOutOnExit(leafSceneEl.current, direction);
            animate.removeClassOnExit(
              greenLeafOneEl.current,
              "moved",
              direction
            );
            animate.removeClassOnExit(
              greenLeafTwoEl.current,
              "moved",
              direction
            );
            animate.removeClassOnExit(
              greenLeafThreeEl.current,
              "moved",
              direction
            );
            break;
          }
          case 6: {
            animate.fadeInOnExit(leafSceneEl.current, direction);
            break;
          }
          case 7: {
            animate.fadeOutOnExit(houseExteriorSceneEl.current, direction);
            break;
          }
          case 8: {
            animate.fadeOutOnExit(
              houseExteriorImgSceneTwoEl.current,
              direction
            );
            animate.fadeInOnExit(
              houseExteriorTextSceneOneEl.current,
              direction
            );
            animate.fadeOutOnExit(
              houseExteriorTextSceneTwoEl.current,
              direction
            );
            break;
          }
          case 9: {
            animate.fadeOutOnExit(
              houseExteriorImgSceneThreeEl.current,
              direction
            );
            animate.fadeInOnExit(
              houseExteriorTextSceneTwoEl.current,
              direction
            );
            animate.fadeOutOnExit(
              houseExteriorTextSceneThreeEl.current,
              direction
            );
            break;
          }
          case 10: {
            animate.fadeOutOnExit(
              houseExteriorImgSceneFourEl.current,
              direction
            );
            animate.fadeInOnExit(
              houseExteriorTextSceneThreeEl.current,
              direction
            );
            animate.fadeOutOnExit(
              houseExteriorTextSceneFourEl.current,
              direction
            );
            break;
          }
          case 11: {
            if (direction === "up") {
              unfadeAllHouses();
              fadeOrangeGerms();
            }
            animate.fadeInOnExit(
              houseExteriorSceneBackgroundEl.current,
              direction
            );
            animate.fadeOutOnExit(
              houseExteriorImgSceneFiveEl.current,
              direction
            );
            animate.fadeInOnExit(
              houseExteriorTextSceneFourEl.current,
              direction
            );
            animate.fadeOutOnExit(
              houseExteriorTextSceneFiveEl.current,
              direction
            );
            break;
          }
          case 12: {
            if (direction === "up") {
              unfadeOrangeGerms();
            }
            animate.fadeOutOnExit(blockHouseEl.current, direction);
            animate.fadeInOnExit(
              houseExteriorImgSceneFiveEl.current,
              direction
            );
            animate.fadeInOnExit(
              houseExteriorTextSceneFiveEl.current,
              direction
            );
            break;
          }
          case 13: {
            animate.fadeOutOnExit(nurseProfileEl.current, direction);
            animate.fadeOutOnExit(waitingRoomSceneEl.current, direction);
            animate.removeClassOnExit(blockHouseEl.current, "moved", direction);
            animate.fadeOutOnExit(blueGermEl.current, direction);
            break;
          }
          case 14: {
            animate.fadeInOnExit(waitingRoomSceneEl.current, direction);
            animate.fadeInOnExit(blockHouseEl.current, direction);
            setTimeout(() => {
              animate.fadeInOnExit(blueGermEl.current, direction);
            }, 500);
            animate.removeClassOnExit(
              nurseProfileEl.current,
              "moved",
              direction
            );
            animate.fadeOutOnExit(nurseProfileSceneEl.current, direction);
            animate.removeClassOnExit(
              turquoiseBlockEl.current,
              "moved",
              direction
            );
            break;
          }
          case 15: {
            animate.fadeOutOnExit(eyesTextBlockEl.current, direction);
            break;
          }
          case 16: {
            animate.fadeOutOnExit(noseTextBlockEl.current, direction);
            break;
          }
          case 17: {
            animate.fadeOutOnExit(mouthTextBlockEl.current, direction);
            break;
          }
          default:
            break;
        }
      });
  }, [scrolly, step]);

  // const moveLeavessOneTwoStep1 = (progress) => {
  //   const leaf1 = treeLeafOneEl.current;
  //   const leaf2 = treeLeafTwoEl.current;

  //   const top1 = 20 + 9 * progress;
  //   const top2 = 17 + 10 * progress;

  //   leaf1.style.top = `${top1}rem`;
  //   leaf2.style.top = `${top2}rem`;
  // };

  // const moveLeavessOneTwoStep2 = (progress) => {
  //   const leaf1 = treeLeafOneEl.current;
  //   const leaf2 = treeLeafTwoEl.current;

  //   const top1 = 29 + 8 * progress;
  //   const top2 = 27 + 10 * progress;

  //   leaf1.style.top = `${top1}rem`;
  //   leaf2.style.top = `${top2}rem`;
  // };

  // const moveLeavesThreeFourStep1 = (progress) => {
  //   const leaf3 = treeLeafThreeEl.current;
  //   const leaf4 = treeLeafFourEl.current;

  //   const top3 = 16 + 11 * progress;
  //   const top4 = 15 + 9.5 * progress;
  //   const left4 = 15 + 1 * progress;

  //   leaf3.style.top = `${top3}rem`;
  //   leaf4.style.top = `${top4}rem`;
  //   leaf4.style.left = `${left4}rem`;
  // };

  const fadeAllHouses = () => {
    const houses = [
      houseExteriorImgSceneOneEl,
      houseExteriorImgSceneTwoEl,
      houseExteriorImgSceneThreeEl,
      houseExteriorImgSceneFourEl,
    ];
    houses.forEach((house) => {
      house.current.style.transitionDuration = "0s";
      house.current.style.opacity = 0;
    });
  };

  const unfadeAllHouses = () => {
    const houses = [
      houseExteriorImgSceneOneEl,
      houseExteriorImgSceneTwoEl,
      houseExteriorImgSceneThreeEl,
      houseExteriorImgSceneFourEl,
    ];
    houses.forEach((house) => {
      house.current.style.transitionDuration = "";
      house.current.style.opacity = 1;
    });
  };

  const fadeOrangeGerms = () => {
    const germs = [germOneImgEl, germTwoImgEl, germThreeImgEl];
    germs.forEach((germ) => {
      germ.current.style.opacity = 0;
    });
  };

  const unfadeOrangeGerms = () => {
    const germs = [germOneImgEl, germTwoImgEl, germThreeImgEl];
    germs.forEach((germ) => {
      germ.current.style.opacity = 1;
    });
  };

  return (
    <section className="wrapper">
      <div className="sticky-container">
        <div className="part4">
          <div className="block-house" ref={blockHouseEl}>
            <img
              src={blockHouseImg}
              alt="House made of childrens blocks"
              className="img-fluid"
            />
          </div>
          <div className="nurse-profile" ref={nurseProfileEl}>
            <img src={nurseProfileImg} alt="Nurse" className="img-fluid" />
          </div>
          <div className="scene scene-tree" ref={treeSceneEl}>
            <div className="scene-background">
              <img src={parkBackgroundImg} alt="Park" className="img-fluid" />
            </div>
            <div className="tree-img">
              <img src={treeImg} alt="tree" className="img-fluid" />
            </div>
            <div className="text-block">
              <div className="text-block-1" ref={leafTextBlockOneEl}>
                When leaves fall, <br />
                <span className="span-1" ref={leafTextBlockTwoEl}>
                  a lot of them fall
                </span>{" "}
                <br />{" "}
                <span className="span-2" ref={leafTextBlockThreeEl}>
                  near the tree.
                </span>
              </div>
              {/* <div className="text-block-2" ref={leafTextBlockTwoEl}>
                a lot of them fall…
              </div>
              <div className="text-block-3" ref={leafTextBlockThreeEl}>
                near the tree.
              </div> */}
              <div className="text-block-4" ref={leafTextBlockFourEl}>
                But some of the leaves will get caught by the wind and travel
                wherever it blows.
              </div>
            </div>
            <div className="wind wind-1" ref={windOneEl}>
              <img src={arrowImg} alt="Arrow" className="img-fluid" />
            </div>
            <div className="wind wind-2" ref={windTwoEl}>
              <img src={arrowImg} alt="Arrow" className="img-fluid" />
            </div>
            <div className="leaf ground-leaf ground-leaf-1">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf ground-leaf ground-leaf-2">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf ground-leaf ground-leaf-3">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf ground-leaf ground-leaf-4">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf ground-leaf ground-leaf-5">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf tree-leaf tree-leaf-1" ref={treeLeafOneEl}>
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf tree-leaf tree-leaf-2" ref={treeLeafTwoEl}>
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf tree-leaf tree-leaf-3" ref={treeLeafThreeEl}>
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf tree-leaf tree-leaf-4" ref={treeLeafFourEl}>
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf tree-leaf tree-leaf-5">
              <img src={leaf2Img} alt="Leaf" className="img-fluid" />
            </div>
          </div>
          <div className="scene scene-leaf" ref={leafSceneEl}>
            <div className="leaf-img leaf-img-1" ref={greenLeafOneEl}>
              <img src={leafImg} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf-img leaf-img-2" ref={greenLeafTwoEl}>
              <img src={leafImg} alt="Leaf" className="img-fluid" />
            </div>
            <div className="leaf-img leaf-img-3" ref={greenLeafThreeEl}>
              <img src={leafImg} alt="Leaf" className="img-fluid" />
            </div>
            <div className="text-block">
              These leaves will fall a little further away from the tree.
            </div>
          </div>
          <div className="scene scene-home-exterior" ref={houseExteriorSceneEl}>
            <div
              className="scene-background"
              ref={houseExteriorSceneBackgroundEl}
            >
              <img
                className="img-fluid"
                src={neighborhoodBackgroundImg}
                alt="Neighborhood"
              />
            </div>
            <div
              className="text-block text-block-state-1"
              ref={houseExteriorTextSceneOneEl}
            >
              These leaves fall…
            </div>
            <div
              className="text-block text-block-state-2"
              ref={houseExteriorTextSceneTwoEl}
            >
              These leaves fall on the ground…
            </div>
            <div
              className="text-block text-block-state-3"
              ref={houseExteriorTextSceneThreeEl}
            >
              These leaves fall on the ground, the roof of your house…
            </div>
            <div
              className="text-block text-block-state-4"
              ref={houseExteriorTextSceneFourEl}
            >
              These leaves fall on the ground, the roof of your house, and your
              car.
            </div>
            <div
              className="text-block text-block-state-5"
              ref={houseExteriorTextSceneFiveEl}
            >
              Once the droplets land on a surface and you touch it, the virus
              can sometimes survive long enough to get on your hands.
            </div>
            <div
              className="house-img house-img-state-1"
              ref={houseExteriorImgSceneOneEl}
            >
              <img src={houseSceneOneImg} alt="House" className="img-fluid" />
            </div>
            <div
              className="house-img house-img-state-2"
              ref={houseExteriorImgSceneTwoEl}
            >
              <img src={houseSceneTwoImg} alt="House" className="img-fluid" />
            </div>
            <div
              className="house-img house-img-state-3"
              ref={houseExteriorImgSceneThreeEl}
            >
              <img src={houseSceneThreeImg} alt="House" className="img-fluid" />
            </div>
            <div
              className="house-img house-img-state-4"
              ref={houseExteriorImgSceneFourEl}
            >
              <img src={houseSceneFourImg} alt="House" className="img-fluid" />
            </div>
            <div
              className="house-img house-img-state-5"
              ref={houseExteriorImgSceneFiveEl}
            >
              <img
                src={houseSceneFiveOrangeImg}
                alt="House"
                className="img-fluid"
              />
            </div>
            <div className="germ germ-1" ref={germOneImgEl}>
              <img src={germSixOrangeImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-2" ref={germTwoImgEl}>
              <img src={germThreeOrangeImg} alt="Germ" className="img-fluid" />
            </div>
            <div className="germ germ-3" ref={germThreeImgEl}>
              <img src={germOneOrangeImg} alt="Germ" className="img-fluid" />
            </div>
          </div>
          <div className="scene scene-waiting-room" ref={waitingRoomSceneEl}>
            <div className="scene-background">
              <img
                src={waitingRoomBackgroundImg}
                alt=""
                className="img-fluid"
              />
            </div>
            <div className="toddler-img">
              <img
                src={blockToddlerImg}
                alt="Toddler with blocks"
                className="img-fluid"
              />
            </div>
            <div className="germ rotate" ref={blueGermEl}>
              <img src={blueGerm} alt="Germ" className="img-fluid" />
            </div>
          </div>
          <div className="scene scene-nurse-profile" ref={nurseProfileSceneEl}>
            <div className="text-block">
              Viruses can also get onto surfaces when an infected person touches
              the surface after touching their
            </div>

            <div
              className="outline-text-block outline-text-block-eyes"
              ref={eyesTextBlockEl}
            >
              EYES
            </div>
            <div
              className="outline-text-block outline-text-block-nose"
              ref={noseTextBlockEl}
            >
              NOSE
            </div>
            <div
              className="outline-text-block outline-text-block-mouth"
              ref={mouthTextBlockEl}
            >
              MOUTH
            </div>
            <div className="turquoise-block" ref={turquoiseBlockEl}></div>
          </div>
        </div>
      </div>

      {animationSequence.map(({ height, description }, index) => {
        return (
          <Step
            stepSection={step}
            stepNumber={index}
            stepDescription={description}
            height={height}
            key={index}
          />
        );
      })}
    </section>
  );
}
